import { render, staticRenderFns } from "./RealisationSidebarContactsTab.vue?vue&type=template&id=6818625c&scoped=true"
import script from "./RealisationSidebarContactsTab.vue?vue&type=script&lang=js"
export * from "./RealisationSidebarContactsTab.vue?vue&type=script&lang=js"
import style0 from "./RealisationSidebarContactsTab.vue?vue&type=style&index=0&id=6818625c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818625c",
  null
  
)

export default component.exports